'use strict';

let requireOrNull = require;
if (!process.env.WEBPACK) {
  requireOrNull = str => str;
}

const critModules = [
  {
    name: 'BuyButtonForm',
    module: requireOrNull(
      '../../../../modules/buy_button_form/frontend/desktop'
    ),
    featureCheck: serverObj => serverObj.usesBuyButtonForm,
  },
  {
    name: 'Juice',
    module: requireOrNull(
      '../../../../modules/juice_program/frontend/juice_program'
    ),
    featureCheck: serverObj =>
      serverObj.juiceProgramInfo &&
      serverObj.juiceProgramInfo.isJuiceProgramEnabled,
  },
  {
    name: 'CashBack',
    module: requireOrNull(
      '../../../../modules/cash_back/desktop/frontend/cash_back'
    ),
    featureCheck: serverObj => serverObj.cashBack,
  },
  {
    name: 'Cart',
    module: requireOrNull('../../../../modules/cart/frontend/index'),
    featureCheck: serverObj => serverObj.cart,
  },
  {
    name: 'FinePrint',
    module: requireOrNull('../../../../modules/fine_print/frontend'),
    featureCheck: serverObj => serverObj.usesBuyButtonForm,
  },
];

const nonCritModules = [
  {
    name: 'AsyncScripts',
    module: requireOrNull('../async_scripts/local'),
  },
  {
    name: 'Value Proposition',
    module: requireOrNull('../../../../modules/value_proposition/frontend'),
    featureCheck: serverObj => serverObj.valueProposition,
  },
  {
    name: 'Wishlist',
    module: requireOrNull(
      '../../../../modules/wishlist_button/frontend/wishlist'
    ),
    featureCheck: serverObj => serverObj.wishlist,
  },
  {
    name: 'TTDPassViewDetailsModal',
    module: requireOrNull(
      '../../../../modules/ttd_pass_available_deals/frontend/index'
    ),
  },
];

module.exports = { critModules, nonCritModules };
